import dayjs from "dayjs";
import { Workbook } from "exceljs";

const commonStyle = {
  border: {
    top: { style: "thin", color: { argb: "#000000" } },
    left: { style: "thin", color: { argb: "#000000" } },
    bottom: { style: "thin", color: { argb: "#000000" } },
    right: { style: "thin", color: { argb: "#000000" } },
  },
  fill: {
    type: "pattern",
    fgColor: { argb: "FFFFFF00" },
    bgColor: { argb: "FF0000FF" },
  },
};

// 숫자 포맷 스타일 (천 단위 구분자)
const numberStyle = {
  ...commonStyle,
  numFmt: '#,##0'
};

const depositNWithdrawalInquiryColumns = [
  { header: "요청시간", key: "createdAt", style: commonStyle, width: 20 },
  { header: "구분", key: "isDeposit", style: commonStyle, width: 8 },
  { header: "상태", key: "status", style: commonStyle, width: 10 },
  { header: "등록번호", key: "id", style: commonStyle, width: 10 },
  { header: "아이디", key: "userId", style: commonStyle, width: 15 },
  { header: "이름", key: "userName", style: commonStyle, width: 12 },
  { header: "유저구분", key: "authority", style: commonStyle, width: 10 },
  { header: "요청금액", key: "request_balance", style: numberStyle, width: 15 },
  { header: "처리시간", key: "endTime", style: commonStyle, width: 20 },
  { header: "처리금액", key: "approved_balance", style: numberStyle, width: 15 },
  { header: "입출금 전 보유금액", key: "before_balance", style: numberStyle, width: 20 },
  { header: "입출금 후 보유금액", key: "after_balance", style: numberStyle, width: 20 },
  { header: "은행", key: "accountBank", style: commonStyle, width: 12 },
  { header: "예금주", key: "accountOwner", style: commonStyle, width: 12 },
  { header: "계좌번호", key: "accountNo", style: commonStyle, width: 20 },
  { header: "추천인", key: "recommendCode", style: commonStyle, width: 12 },
  { header: "비고", key: "memo", style: commonStyle, width: 20 },
];
const depositNWithdrawalColumns = [
  { header: "일자", key: "inquiry_date", style: commonStyle },
  { header: "입금요청건수", key: "deposit_request_count", style: numberStyle },
  { header: "입금승인건수", key: "deposit_approve_count", style: numberStyle },
  { header: "입금거부건수", key: "deposit_refuse_count", style: numberStyle },
  {
    header: "관리자입금건수",
    key: "deposit_manager_count",
    style: numberStyle,
  },
  {
    header: "회원요청입금금액합계",
    key: "deposit_request_sum",
    style: numberStyle,
  },
  {
    header: "입금승인금액합계",
    key: "deposit_approve_sum",
    style: numberStyle,
  },
  { header: "입금거부금액합계", key: "deposit_refuse_sum", style: numberStyle },
  { header: "관리자입금합계", key: "deposit_manager_sum", style: numberStyle },
  { header: "입금처리금액총합", key: "deposit_all_sum", style: numberStyle },
  {
    header: "출금요청건수",
    key: "withdrawal_request_count",
    style: numberStyle,
  },
  {
    header: "출금승인건수",
    key: "withdrawal_approve_count",
    style: numberStyle,
  },
  {
    header: "출금거부건수",
    key: "withdrawal_refuse_count",
    style: numberStyle,
  },
  {
    header: "관리자출금건수",
    key: "withdrawal_manager_count",
    style: numberStyle,
  },
  {
    header: "회원요청출금금액합계",
    key: "withdrawal_request_sum",
    style: numberStyle,
  },
  {
    header: "출금승인금액합계",
    key: "withdrawal_approve_sum",
    style: numberStyle,
  },
  {
    header: "출금거부금액합계",
    key: "withdrawal_refuse_sum",
    style: numberStyle,
  },
  {
    header: "관리자출금합계",
    key: "withdrawal_manager_sum",
    style: numberStyle,
  },
  { header: "출금처리금액총합", key: "withdrawal_all_sum", style: numberStyle },
];

const memberDailyProfitNLossColumns = [
  { header: "날짜", key: "dateId", style: commonStyle, width: 12 },
  {
    header: "주간선물 실현손익",
    key: "domesticProfitNLoss",
    style: numberStyle,
    width: 24,
  },
  {
    header: "주간옵션 실현손익",
    key: "optionProfitNLoss",
    style: numberStyle,
    width: 24,
  },
  {
    header: "야간선물 실현손익",
    key: "night_domestic_profit_loss",
    style: numberStyle,
    width: 24,
  },
  {
    header: "야간옵션 실현손익",
    key: "night_option_profit_loss",
    style: numberStyle,
    width: 24,
  },
  {
    header: "해외선물 실현손익",
    key: "foreignProfitNLoss",
    style: numberStyle,
    width: 24,
  },
  {
    header: "실현손익 수수료",
    key: "pureProfitNLoss",
    style: numberStyle,
    width: 24,
  },
  {
    header: "주간선물 수수료",
    key: "domesticFee",
    style: numberStyle,
    width: 24,
  },
  {
    header: "주간옵션 수수료",
    key: "optionFee",
    style: numberStyle,
    width: 24,
  },
  {
    header: "야간선물 수수료",
    key: "night_domestic_fee",
    style: numberStyle,
    width: 24,
  },
  {
    header: "야간옵션 수수료",
    key: "night_option_fee",
    style: numberStyle,
    width: 24,
  },
  {
    header: "해외선물 수수료",
    key: "foreignFee",
    style: numberStyle,
    width: 24,
  },
  { header: "수수료 합계", key: "totalFee", style: numberStyle, width: 24 },
  { header: "실제손익", key: "profitNLoss", style: numberStyle, width: 24 },
];

const memberListColumns = [
  { header: "아이디", key: "id", style: commonStyle },
  { header: "가입일시", key: "createdAt", style: commonStyle },
  { header: "이름", key: "userName", style: commonStyle },
  { header: "휴대폰", key: "phoneNo", style: commonStyle },
  { header: "이메일", key: "email", style: commonStyle },
  { header: "추천인", key: "recommendCode", style: commonStyle },
  { header: "최종접속일시", key: "lastLogin", style: commonStyle },
  { header: "마지막거래일시", key: "lastTrade", style: commonStyle },
  { header: "접속IP", key: "connectIP", style: commonStyle },
  { header: "접속MAC", key: "connectMAC", style: commonStyle },
  { header: "권한", key: "authority", style: commonStyle },
  { header: "계정상태", key: "userState", style: commonStyle },
  { header: "담보금", key: "userBalance", style: numberStyle },
  { header: "입금은행 아이디", key: "deposit_accountId", style: commonStyle },
  { header: "입금은행", key: "deposit_accountName", style: commonStyle },
  { header: "입금은행명", key: "deposit_accountBank", style: commonStyle },
  {
    header: "입금은행 계좌주",
    key: "deposit_accountOwner",
    style: commonStyle,
  },
  { header: "입금은행 계좌번호", key: "deposit_accountNo", style: commonStyle },
  { header: "출금은행", key: "userAccountBank", style: commonStyle },
  { header: "출금계좌", key: "userAccountNo", style: commonStyle },
  { header: "출금예금주", key: "userAccountOwner", style: commonStyle },
  { header: "국선오버나잇", key: "isOverDomestic", style: commonStyle },
  {
    header: "국선오버나잇 일시",
    key: "updatedData_overDomestic",
    style: commonStyle,
  },
  { header: "옵션오버나잇", key: "isOverOption", style: commonStyle },
  {
    header: "옵션오버나잇 일시",
    key: "updatedData_overOption",
    style: commonStyle,
  },
  { header: "해선오버나잇", key: "isOverForeign", style: commonStyle },
  {
    header: "해선오버나잇 일시",
    key: "updatedData_overForeign",
    style: commonStyle,
  },
  { header: "항셍오버나잇", key: "isOverHangSeng", style: commonStyle },
  {
    header: "항셍오버나잇 일시",
    key: "updatedData_overHangseng",
    style: commonStyle,
  },
  { header: "마이크로", key: "isOverMiniForeign", style: commonStyle },
  {
    header: "마이크로 일시",
    key: "updatedData_miniForeign",
    style: commonStyle,
  },
  { header: "국내선물 수수료", key: "domestic_fee", style: numberStyle },
  { header: "옵션 수수료", key: "option_fee", style: numberStyle },
  { header: "해외선물 수수료", key: "foreign_fee", style: numberStyle },
  { header: "항셍 수수료", key: "hangseng_fee", style: numberStyle },
  {
    header: "국내선물 최대계약수",
    key: "domestic_maxAvailableCount",
    style: commonStyle,
  },
  {
    header: "옵션 최대계약수",
    key: "option_maxAvailableCount",
    style: commonStyle,
  },
  { header: "옵션매도 최대계약수", key: "optionSellCount", style: commonStyle },
  {
    header: "해외선물 최대계약수",
    key: "foreign_maxAvailableCount",
    style: commonStyle,
  },
  {
    header: "항셍 최대계약수",
    key: "hangseng_maxAvailableCount",
    style: commonStyle,
  },
  {
    header: "마이크로해외선물 최대계약수",
    key: "mini_foreign_maxAvailableCount",
    style: commonStyle,
  },
  { header: "메모", key: "memo", style: commonStyle },
];

const memberTotalProfitNLossColumns = [
  { header: "가입일자", key: "createdAt", style: commonStyle, width: 20 },
  { header: "아이디", key: "id", style: commonStyle, width: 15 },
  { header: "이름", key: "userName", style: commonStyle, width: 12 },
  { header: "추천인", key: "recommendCode", style: commonStyle, width: 12 },
  { header: "매매손익", key: "profitNLoss", style: numberStyle, width: 18 },
  { header: "주간선물손익", key: "domesticProfitNLoss", style: numberStyle, width: 18 },
  { header: "주간옵션손익", key: "optionProfitNLoss", style: numberStyle, width: 18 },
  { header: "야간선물손익", key: "night_domestic_profit_loss", style: numberStyle, width: 18 },
  { header: "야간옵션손익", key: "night_option_profit_loss", style: numberStyle, width: 18 },
  { header: "해외선물손익", key: "foreignProfitNLoss", style: numberStyle, width: 18 },
  { header: "총손익합", key: "pureProfitNLoss", style: numberStyle, width: 18 },
  { header: "주간선물수수료", key: "domesticFee", style: numberStyle, width: 18 },
  { header: "주간옵션수수료", key: "optionFee", style: numberStyle, width: 18 },
  { header: "야간선물수수료", key: "night_domestic_fee", style: numberStyle, width: 18 },
  { header: "야간옵션수수료", key: "night_option_fee", style: numberStyle, width: 18 },
  { header: "해외선물수수료", key: "foreignFee", style: numberStyle, width: 18 },
  { header: "총수수료합", key: "totalFee", style: numberStyle, width: 18 },
  { header: "거래일수", key: "traidngDayCount", style: numberStyle, width: 12 }
];

const excelExport = async (fileName, data) => {
  const workbook = new Workbook();
  workbook.addWorksheet(fileName);
  const sheet = workbook.getWorksheet(fileName);

  if (fileName === "입출금내역조회") {
    sheet.columns = depositNWithdrawalInquiryColumns;
  }

  if (fileName === "입출금통계") {
    // 헤더 없이 컬럼 속성만 설정 (2행 헤더를 수동으로 생성)
    sheet.columns = depositNWithdrawalColumns.map(({ header, ...rest }) => rest);

    const headerCellStyle = {
      font: { bold: true },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: commonStyle.border,
    };

    // Row 1: 그룹 헤더 (일자 rowSpan=2, 입금 colSpan=9, 출금 colSpan=9)
    const row1 = sheet.getRow(1);
    row1.getCell(1).value = '일자';
    row1.getCell(2).value = '입금';
    row1.getCell(11).value = '출금';

    // Row 2: 세부 컬럼 헤더
    const row2 = sheet.getRow(2);
    const subHeaders = [
      null,
      '요청건수', '승인건수', '거부건수', '관리자입금건수',
      '회원요청금액합계', '승인금액합계', '거부금액합계', '관리자입금합계', '입금처리금액총합',
      '요청건수', '승인건수', '거부건수', '관리자출금건수',
      '회원요청금액합계', '승인금액합계', '거부금액합계', '관리자출금합계', '출금처리금액총합',
    ];
    subHeaders.forEach((h, i) => {
      if (h != null) row2.getCell(i + 1).value = h;
    });

    // 셀 병합: 프론트엔드 테이블 헤더와 동일한 구조
    sheet.mergeCells('A1:A2'); // 일자 rowSpan=2
    sheet.mergeCells('B1:J1'); // 입금 colSpan=9
    sheet.mergeCells('K1:S1'); // 출금 colSpan=9

    // 헤더 스타일 적용
    [row1, row2].forEach(row => {
      for (let c = 1; c <= 19; c++) {
        const cell = row.getCell(c);
        cell.font = headerCellStyle.font;
        cell.alignment = headerCellStyle.alignment;
        cell.border = headerCellStyle.border;
      }
    });
  }

  if (fileName === "회원목록") {
    sheet.columns = memberListColumns;
  }

  if (fileName === "회원일별손익내역") {
    sheet.columns = memberDailyProfitNLossColumns;
  }

  if (fileName === "회원별총손익") {
    // 헤더 없이 컬럼 속성만 설정 (2행 헤더를 수동으로 생성)
    sheet.columns = memberTotalProfitNLossColumns.map(({ header, ...rest }) => rest);

    const headerCellStyle = {
      font: { bold: true },
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: commonStyle.border,
    };

    // Row 1: 그룹 헤더
    const row1 = sheet.getRow(1);
    row1.getCell(1).value = '고객정보';    // A (colSpan=4)
    row1.getCell(5).value = '매매손익';    // E (rowSpan=2)
    row1.getCell(6).value = '순손익';      // F (colSpan=6)
    row1.getCell(12).value = '수수료';     // L (colSpan=6)
    row1.getCell(18).value = '거래일';     // R (rowSpan=2)

    // Row 2: 세부 컬럼 헤더
    const row2 = sheet.getRow(2);
    const subHeaders = [
      '가입일자', '아이디', '이름', '추천인',
      null,
      '주간선물손익', '주간옵션손익', '야간선물손익', '야간옵션손익', '해외선물손익', '총손익합',
      '주간선물수수료', '주간옵션수수료', '야간선물수수료', '야간옵션수수료', '해외선물수수료', '총수수료합',
      null,
    ];
    subHeaders.forEach((h, i) => {
      if (h != null) row2.getCell(i + 1).value = h;
    });

    // 셀 병합: 프론트엔드 테이블 헤더와 동일한 구조
    sheet.mergeCells('A1:D1');  // 고객정보 colSpan=4
    sheet.mergeCells('E1:E2');  // 매매손익 rowSpan=2
    sheet.mergeCells('F1:K1'); // 순손익 colSpan=6
    sheet.mergeCells('L1:Q1'); // 수수료 colSpan=6
    sheet.mergeCells('R1:R2');  // 거래일 rowSpan=2

    // 헤더 스타일 적용
    [row1, row2].forEach(row => {
      for (let c = 1; c <= 18; c++) {
        const cell = row.getCell(c);
        cell.font = headerCellStyle.font;
        cell.alignment = headerCellStyle.alignment;
        cell.border = headerCellStyle.border;
      }
    });
  }

  data.forEach((item) => {
    sheet.addRow(item);
  });

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `${dayjs().format("YYYY-MM-DD")} ${fileName}.xlsx`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export default excelExport;
